var map = {
	"./app-apple-da-DK.svg": 23823,
	"./app-apple-de-DE.svg": 58397,
	"./app-apple-en-GB.svg": 9706,
	"./app-apple-en-US.svg": 59453,
	"./app-apple-es-ES.svg": 35043,
	"./app-apple-es-MX.svg": 78745,
	"./app-apple-fr-FR.svg": 70123,
	"./app-apple-it-IT.svg": 44035,
	"./app-apple-nb-NO.svg": 69606,
	"./app-apple-nl-NL.svg": 39325,
	"./app-apple-pl-PL.svg": 49580,
	"./app-apple-pt-BR.svg": 96595,
	"./app-apple-pt-PT.svg": 87967,
	"./app-apple-sv-SE.svg": 32325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98569;